import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Transform 365 Business Solutions. All rights reserved.</p>
      <p className="footer-contact">
        <strong>Email:</strong> <a href="mailto:info@transform365.ca">info@transform365.ca</a> |{' '}
        <strong>Phone:</strong> <a href="tel:+14034012747">403-401-2747</a> |{' '}
        <strong>Address:</strong> Calgary, AB, Canada
      </p>
    </footer>
  );
};

export default Footer;
